import ConnectedRewardsSummaryModule from './ConnectedRewardsSummaryModule';

export default ConnectedRewardsSummaryModule;
